import React, { useState } from "react";
import styled from "styled-components";
import { getOptimizedUrl } from "../../utils/cloudinaryOptimize";
import menuPlaceholder from "../../assets/img/restaurant-dish-placeholder.png";

const ImageWithFallback = ({ imageUrl }) => {
  const sources = [...new Set([
    imageUrl ? getOptimizedUrl(imageUrl, "thumbnail") : null,
    imageUrl,
    menuPlaceholder,
  ].filter(Boolean))];
  const [index, setIndex] = useState(0);
  return (
    <Photo
      src={sources[Math.min(index, sources.length - 1)]}
      alt=""
      loading="lazy"
      onError={() => setIndex((current) => Math.min(current + 1, sources.length - 1))}
    />
  );
};

// Reset the fallback ladder when a newer basket supplies a different photo.
const GroupBasketItemImage = ({ imageUrl }) => (
  <ImageWithFallback key={imageUrl || "placeholder"} imageUrl={imageUrl} />
);

const Photo = styled.img`
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 12px;
  object-fit: cover;
  background: #f3f7ef;

  @media (max-width: 480px) {
    width: 48px;
    height: 48px;
  }
`;

export default GroupBasketItemImage;
